/**
 * jQuery.countdown - Countdown timer using server time for delta
 * Copyright (c) 2018, 2021 Hiltonian Media Ltd www.hiltonian.com
 * Use not permitted without written permission
 * Date: 17/05/2022
 * @author Richard Hilton
 * @version 2.1.0
 */
 (function($){
	$.fn.countdown = function(options) {
		this.each(function() {
			clearTimeout($(this).data('timer'));
		});
		if (options === 'stop') {
			return;
		}

		if (!options) options = {};

		const handleize = function(string) {
			return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
		}

		return this.each(function() {
			var timer = $(this);
			var settings = {
				load: null,
				end: null,
				day: 'day',
				hour: 'hour',
				minute: 'minute',
				second: 'second',
				plural: 's',
				hideZero: false,
				separator: ' ',
				pluralWrap: '<span></span>',
				onEnd: () => {}
			};
			$.extend(settings, timer.data(), options);

			var end = parseInt(settings.end) - (parseInt(settings.load) - Date.now());
			
			var s = 1000;
			var m = s * 60;
			var h = m * 60;
			var d = h * 24;
			var pad = "00";

			var interval = s; // 1s
			var expected = Date.now();
			
			function updateCountdown() {
				var time = Date.now();
				var drift = time - expected;
				if (drift > interval) drift = 0;
				var days = 0; var hours = 0; var minutes = 0; var seconds = 0;
				var remaining = end - time;
				if (remaining > 0) {
					var days = Math.floor(remaining / d);
					remaining -= days * d;
					var hours = Math.floor(remaining / h);
					remaining -= hours * h;
					var minutes = Math.floor(remaining / m);
					remaining -= minutes * m;
					var seconds = Math.floor(remaining / s);
				}

				var wrapped_plural = null;
				if (settings.pluralWrap != null) {
					wrapped_plural = $(settings.pluralWrap).html(settings.plural).css('visibility', 'hidden')[0].outerHTML;
				}

				const days_label = settings.day + (days != 1 ? settings.plural : '');
				const hours_label = settings.hour + (hours != 1 ? settings.plural : '');
				const minutes_label = settings.minute + (minutes != 1 ? settings.plural : wrapped_plural);
				const seconds_label = settings.second + (seconds != 1 ? settings.plural : wrapped_plural);

				const days_html = days == 0 && settings.hideZero ? '' : `<span class="days interval"><span class="number">${(pad + days).slice(-2)}</span> <span class="period">${days_label}</span></span>`;
				const hours_html = days + hours == 0 && settings.hideZero ? '' : `<span class="hours interval"><span class="number">${(pad + hours).slice(-2)}</span> <span class="period">${hours_label}</span></span>`;
				const minutes_html = days + hours + minutes == 0 && settings.hideZero ? '' : `<span class="minutes interval"><span class="number">${(pad + minutes).slice(-2)}</span> <span class="period">${minutes_label}</span></span>`;
				const seconds_html = `<span class="seconds interval"><span class="number">${(pad + seconds).slice(-2)}</span> <span class="period">${seconds_label}</span></span>`;
				const separator = settings.separator.length ? `<span class="separator">${settings.separator}</span>` : ' ';

				const segments = [days_html, hours_html, minutes_html, seconds_html];

				timer.html(segments.filter(function(str) { return str.length > 0; }).join(separator));

				expected += interval;
				if (remaining > 0) {
					var timeout = setTimeout(updateCountdown, Math.max(0, interval - drift));
					timer.data('timer', timeout);
				} else {
					const onEnd = settings.onEnd.bind(timer);
					onEnd();
				}
			}
			updateCountdown();
		});
	};
})(jQuery);